// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatList-Content .accordion-body {
  display: flex;
  flex-direction: column;
}

.ChatList-Messages {
  height: 250px;
  flex-grow: 1;
  overflow-y: auto;
}

.ChatList-Footer {
  font-size: 1.2rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
}

.ChatList-ChatInput {
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: var(--bs-border-radius);
  border: 2px solid var(--bs-secondary-subtle);
  position: relative;
}
.ChatList-ChatInput .Field {
  margin: 0;
  padding: 0;
  position: static;
}
.ChatList-ChatInput .Textarea.form-control {
  border: none;
  outline: none;
  box-shadow: none !important;
  resize: none;
  overflow-y: auto;
  max-height: 120px;
}
.ChatList-ChatInput .Field > .Field-Feedback {
  top: 100%;
  bottom: -1.5rem;
  left: auto;
  right: 0.75rem;
  margin-top: 0.25rem;
  border-top: none;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.ChatList-QuickReplies {
  flex-wrap: nowrap;
  padding-bottom: 0.25rem;
}
.ChatList-QuickReplies .btn {
  flex-shrink: 0;
}
.ChatList-QuickReplies .ChatList-QuickReply {
  background-color: #e9ecef;
  color: var(--bs-body-color);
  font-weight: 500;
  box-shadow: none;
  border: 0.5px solid rgba(27, 58, 92, 0.2);
  padding: 0.3rem 0.8rem;
}
.ChatList-QuickReplies .ChatList-QuickReply:hover {
  background-color: #dde1e5;
}
.ChatList-QuickReplies .ChatList-QuickReply:active, .ChatList-QuickReplies .ChatList-QuickReply:focus:active {
  background-color: var(--bs-primary) !important;
  color: var(--bs-white);
}

.ChatList-ImageUploadContainer {
  align-self: flex-end;
}

.ChatList-Image {
  border-bottom: 2px solid var(--bs-secondary-subtle);
}
.ChatList-Image .ChatList-ImageName {
  flex: 1;
  background: transparent;
  border: none;
}
.ChatList-Image .ChatList-ImageDelete {
  background: transparent;
  color: var(--bs-primary);
  border: none;
  box-shadow: none !important;
}
.ChatList-Image .ChatList-ImageDelete:hover {
  color: var(--bs-danger);
}

.ChatList-ChatSubmit {
  color: var(--bs-primary);
  cursor: pointer;
}
.ChatList-ChatSubmit:hover {
  color: var(--bs-secondary);
}

.ChatList-ImageUpload {
  background: transparent !important;
  border: 2px solid var(--bs-secondary-subtle) !important;
  border-radius: var(--bs-border-radius) !important;
  color: var(--bs-primary);
  box-shadow: none !important;
}
.ChatList-ImageUpload:hover {
  color: var(--bs-secondary);
}`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/ChatList/ChatListContent/styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;AAAJ;;AAGA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAAF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sCAAA;EACA,4CAAA;EACA,kBAAA;AACF;AAAE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AAEJ;AAAE;EACE,YAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AAAE;EACE,SAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,iBAAA;EACA,uBAAA;AACF;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;EACA,sBAAA;AAEJ;AADI;EACE,yBAAA;AAGN;AADI;EAEE,8CAAA;EACA,sBAAA;AAEN;;AAGA;EACE,oBAAA;AAAF;;AAGA;EACE,mDAAA;AAAF;AACE;EACE,OAAA;EACA,uBAAA;EACA,YAAA;AACJ;AACE;EACE,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,2BAAA;AACJ;AAAI;EACE,uBAAA;AAEN;;AAGA;EACE,wBAAA;EACA,eAAA;AAAF;AACE;EACE,0BAAA;AACJ;;AAGA;EACE,kCAAA;EACA,uDAAA;EACA,iDAAA;EACA,wBAAA;EACA,2BAAA;AAAF;AACE;EACE,0BAAA;AACJ","sourcesContent":[".ChatList-Content {\n  .accordion-body {\n    display: flex;\n    flex-direction: column;\n  }\n}\n.ChatList-Messages {\n  height: 250px;\n  flex-grow: 1;\n  overflow-y: auto;\n}\n.ChatList-Footer {\n  font-size: 1.2rem;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding-bottom: 0.75rem;\n}\n\n.ChatList-ChatInput {\n  height: 100%;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: var(--bs-border-radius);\n  border: 2px solid var(--bs-secondary-subtle);\n  position: relative;\n  .Field {\n    margin: 0;\n    padding: 0;\n    position: static;\n  }\n  .Textarea.form-control {\n    border: none;\n    outline: none;\n    box-shadow: none !important;\n    resize: none;\n    overflow-y: auto;\n    max-height: 120px;\n  }\n  .Field > .Field-Feedback {\n    top: 100%;\n    bottom: -1.5rem;\n    left: auto;\n    right: 0.75rem;\n    margin-top: 0.25rem;\n    border-top: none;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n  }\n}\n\n.ChatList-QuickReplies {\n  flex-wrap: nowrap;\n  padding-bottom: 0.25rem;\n  .btn {\n    flex-shrink: 0;\n  }\n  .ChatList-QuickReply {\n    background-color: #e9ecef;\n    color: var(--bs-body-color);\n    font-weight: 500;\n    box-shadow: none;\n    border: 0.5px solid rgba(27, 58, 92, 0.2);\n    padding: 0.3rem 0.8rem;\n    &:hover {\n      background-color: #dde1e5;\n    }\n    &:active,\n    &:focus:active {\n      background-color: var(--bs-primary) !important;\n      color: var(--bs-white);\n    }\n  }\n}\n\n.ChatList-ImageUploadContainer {\n  align-self: flex-end;\n}\n\n.ChatList-Image {\n  border-bottom: 2px solid var(--bs-secondary-subtle);\n  .ChatList-ImageName {\n    flex: 1;\n    background: transparent;\n    border: none;\n  }\n  .ChatList-ImageDelete {\n    background: transparent;\n    color: var(--bs-primary);\n    border: none;\n    box-shadow: none !important;\n    &:hover {\n      color: var(--bs-danger);\n    }\n  }\n}\n\n.ChatList-ChatSubmit {\n  color: var(--bs-primary);\n  cursor: pointer;\n  &:hover {\n    color: var(--bs-secondary);\n  }\n}\n\n.ChatList-ImageUpload {\n  background: transparent !important;\n  border: 2px solid var(--bs-secondary-subtle) !important;\n  border-radius: var(--bs-border-radius) !important;\n  color: var(--bs-primary);\n  box-shadow: none !important;\n  &:hover {\n    color: var(--bs-secondary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
